import { render, staticRenderFns } from "./jd-address.vue?vue&type=template&id=12c9e458&scoped=true&"
import script from "./jd-address.vue?vue&type=script&lang=js&"
export * from "./jd-address.vue?vue&type=script&lang=js&"
import style0 from "./jd-address.vue?vue&type=style&index=0&id=12c9e458&prod&lang=less&scoped=true&"
import style1 from "./jd-address.vue?vue&type=style&index=1&id=12c9e458&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9e458",
  null
  
)

export default component.exports